
declare global {
    interface Window {
        getTimeZoneAzureFunction: string;
        createServiceProviderFunction: string;
    }
}

namespace gorelo.web {
    export interface IApiConstants {
        actions: {
            gettimezoneazurefunction: string;
            createserviceproviderazurefunction: string;
            validateserviceproviderazurefunction: string;
            sendotpazurefunction: string;
            verifyotpazurefunction: string;
        }

        code: {
            gettimezoneazurefunctioncode: string;
            createserviceproviderazurefunctioncode: string;
            validateserviceproviderazurefunctioncode: string;
            sendotpazurefunctioncode: string;
            verifyotpazurefunctioncode: string;
        }
    }
}

const signupFunctionBaseUrl = import.meta.env.VITE_signupAPIUrl;

// timeout constant
export const dropdownSearchTimeout = 300;



export const apiConstants: gorelo.web.IApiConstants = {

    actions: {
        gettimezoneazurefunction: "GetTimezones",
        createserviceproviderazurefunction: "CreateServiceProviderFunction",
        validateserviceproviderazurefunction: "ValidateServiceProviderFunction",
        sendotpazurefunction: "SendOTPCodeFunction",
        verifyotpazurefunction: "VerifyOTPCodeFunction",
    },
    code: {
        gettimezoneazurefunctioncode: import.meta.env.VITE_getTimeZoneAzureFunctionCode,
        createserviceproviderazurefunctioncode: import.meta.env.VITE_CreateServiceProviderFunctionCode,
        validateserviceproviderazurefunctioncode: import.meta.env.VITE_ValidateServiceProviderFunctionCode,
        sendotpazurefunctioncode: import.meta.env.VITE_SendOTPCodeFunctionCode,
        verifyotpazurefunctioncode: import.meta.env.VITE_VerifyOTPCodeFunctionCode,
    }
};

export const constants = {

    apiUrl: {

        serviceProviderUrls: {
            createServiceProvider: signupFunctionBaseUrl + "/api/" + apiConstants.actions.createserviceproviderazurefunction + "?code=" + apiConstants.code.createserviceproviderazurefunctioncode,
            getTimeZoneAzureFunction: signupFunctionBaseUrl + "/api/" + apiConstants.actions.gettimezoneazurefunction + "?code=" + apiConstants.code.gettimezoneazurefunctioncode,
            validateserviceprovider: signupFunctionBaseUrl + "/api/" + apiConstants.actions.validateserviceproviderazurefunction + "?code=" + apiConstants.code.validateserviceproviderazurefunctioncode,
            sendotp: signupFunctionBaseUrl + "/api/" + apiConstants.actions.sendotpazurefunction + "?code=" + apiConstants.code.sendotpazurefunctioncode,
            verifyotp: signupFunctionBaseUrl + "/api/" + apiConstants.actions.verifyotpazurefunction + "?code=" + apiConstants.code.verifyotpazurefunctioncode,
        },

        
    },
    localStorage: {
        keys: {
            rules: "rules",
            routes: "routes",
        }
    },
    validations: {
        phoneNumberMinLength: 6,
        phoneNumberMaxLength: 15,
        emailMaxLength: 200
    },
    AppVersion: "api-version=1.0",
};

